{
  "labels": {
    "signUp": "",
    "signIn": "",
    "paste": "Einfügen",
    "pasteAsPlaintext": "Als unformatierten Text einfügen",
    "pasteCharts": "Diagramme einfügen",
    "chartType_bar": "Balkendiagramm",
    "chartType_line": "Liniendiagramm",
    "chartType_radar": "Netzdiagramm",
    "chartType_plaintext": "Klartext",
    "selectAll": "Alle auswählen",
    "multiSelect": "Element zur Auswahl hinzufügen",
    "moveCanvas": "Zeichenfläche verschieben",
    "cut": "Ausschneiden",
    "copy": "Kopieren",
    "copyAsPng": "In Zwischenablage kopieren (PNG)",
    "copyAsSvg": "In Zwischenablage kopieren (SVG)",
    "copyText": "Als Text in Zwischenablage kopieren",
    "copySource": "Quelle in Zwischenablage kopieren",
    "convertToCode": "In Code konvertieren",
    "bringForward": "Nach vorne",
    "sendToBack": "In den Hintergrund",
    "bringToFront": "In den Vordergrund",
    "sendBackward": "Nach hinten",
    "delete": "Löschen",
    "copyStyles": "Formatierung kopieren",
    "pasteStyles": "Formatierung übernehmen",
    "stroke": "Strich",
    "changeStroke": "Strichfarbe ändern",
    "background": "Hintergrund",
    "changeBackground": "Hintergrundfarbe ändern",
    "fill": "Füllung",
    "strokeWidth": "Strichstärke",
    "strokeStyle": "Konturstil",
    "strokeStyle_solid": "Durchgezogen",
    "strokeStyle_dashed": "Gestrichelt",
    "strokeStyle_dotted": "Gepunktet",
    "sloppiness": "Sauberkeit",
    "pressure": "",
    "pressure_constant": "",
    "pressure_variable": "",
    "opacity": "Deckkraft",
    "textAlign": "Textausrichtung",
    "edges": "Kanten",
    "sharp": "Scharf",
    "round": "Rund",
    "arrowheads": "Pfeilspitzen",
    "arrowhead_none": "Keine",
    "arrowhead_arrow": "Pfeil",
    "arrowhead_bar": "Balken",
    "arrowhead_circle": "Kreis",
    "arrowhead_circle_outline": "Kreis (Umrandung)",
    "arrowhead_triangle": "Dreieck",
    "arrowhead_triangle_outline": "Dreieck (Umrandung)",
    "arrowhead_diamond": "Raute",
    "arrowhead_diamond_outline": "Raute (Umrandung)",
    "arrowhead_crowfoot_many": "Krähenfuß (viele)",
    "arrowhead_crowfoot_one": "Krähenfuß (einer)",
    "arrowhead_crowfoot_one_or_many": "Krähenfuß (einer oder viele)",
    "arrowhead_cardinality_one": "Kardinalität (eins)",
    "arrowhead_cardinality_many": "Kardinalität (viele)",
    "arrowhead_cardinality_one_or_many": "Kardinalität (eins oder viele)",
    "arrowhead_cardinality_exactly_one": "Kardinalität (genau eins)",
    "arrowhead_cardinality_zero_or_one": "Kardinalität (null oder eins)",
    "arrowhead_cardinality_zero_or_many": "Kardinalität (null oder viele)",
    "more_options": "Weitere Optionen",
    "cardinality": "Kardinalität",
    "arrowtypes": "Pfeiltyp",
    "arrowtype_sharp": "Scharfer Pfeil",
    "arrowtype_round": "Gebogener Pfeil",
    "arrowtype_elbowed": "Abgewinkelter Pfeil",
    "fontSize": "Schriftgröße",
    "fontFamily": "Schriftfamilie",
    "addWatermark": "\"Made with Excalidraw\" hinzufügen",
    "handDrawn": "Handgezeichnet",
    "normal": "Normal",
    "code": "Code",
    "small": "Klein",
    "medium": "Mittel",
    "large": "Groß",
    "veryLarge": "Sehr groß",
    "solid": "Deckend",
    "hachure": "Schraffiert",
    "zigzag": "Zickzack",
    "crossHatch": "Kreuzschraffiert",
    "thin": "Dünn",
    "bold": "Fett",
    "left": "Links",
    "center": "Zentriert",
    "right": "Rechts",
    "extraBold": "Extra Fett",
    "architect": "Architekt",
    "artist": "Künstler",
    "cartoonist": "Karikaturist",
    "fileTitle": "Dateiname",
    "colorPicker": "Farbwähler",
    "canvasColors": "Auf Zeichenfläche verwendet",
    "canvasBackground": "Zeichenflächenhintergrund",
    "drawingCanvas": "Zeichenfläche",
    "clearCanvas": "Zeichenfläche löschen",
    "layers": "Ebenen",
    "actions": "Aktionen",
    "language": "Sprache",
    "liveCollaboration": "Live-Zusammenarbeit...",
    "duplicateSelection": "Duplizieren",
    "untitled": "Unbenannt",
    "name": "Name",
    "yourName": "Dein Name",
    "madeWithExcalidraw": "Made with Excalidraw",
    "group": "Auswahl gruppieren",
    "ungroup": "Gruppierung aufheben",
    "collaborators": "Mitarbeitende",
    "you": "",
    "toggleGrid": "Raster umschalten",
    "loadingScene": "Lade Zeichnung…",
    "loadScene": "Szene aus Datei laden",
    "align": "Ausrichten",
    "alignTop": "Obere Kanten",
    "alignBottom": "Untere Kanten",
    "alignLeft": "Linke Kanten",
    "alignRight": "Rechte Kanten",
    "centerVertically": "Vertikal zentrieren",
    "centerHorizontally": "Horizontal zentrieren",
    "distributeHorizontally": "Horizontal verteilen",
    "distributeVertically": "Vertikal verteilen",
    "flipHorizontal": "Horizontal spiegeln",
    "flipVertical": "Vertikal spiegeln",
    "viewMode": "Ansichtsmodus",
    "share": "Teilen",
    "showStroke": "Auswahl für Strichfarbe anzeigen",
    "showBackground": "Hintergrundfarbe auswählen",
    "showFonts": "Schriftauswahl anzeigen",
    "toggleTheme": "Helles/dunkles Design umschalten",
    "theme": "Design",
    "decreaseFontSize": "Schriftgröße verringern",
    "increaseFontSize": "Schriftgröße erhöhen",
    "unbindText": "Text lösen",
    "bindText": "Text an Container binden",
    "createContainerFromText": "Text in Container einbetten",
    "link": {
      "edit": "Link bearbeiten",
      "editEmbed": "Einbettbaren Link bearbeiten",
      "create": "Link hinzufügen",
      "label": "Link",
      "labelEmbed": "Verlinken & einbetten",
      "empty": "Kein Link festgelegt",
      "hint": "Link hier eingeben oder einfügen",
      "goToElement": "Gehe zu Zielelement"
    },
    "lineEditor": {
      "edit": "Linie bearbeiten",
      "editArrow": "Pfeil bearbeiten"
    },
    "polygon": {
      "breakPolygon": "Polygon auftrennen",
      "convertToPolygon": "In Polygon umwandeln"
    },
    "elementLock": {
      "lock": "Sperren",
      "unlock": "Entsperren",
      "lockAll": "Alle sperren",
      "unlockAll": "Alle entsperren"
    },
    "sidebarLock": "Seitenleiste offen lassen",
    "selectAllElementsInFrame": "Alle Elemente im Rahmen auswählen",
    "removeAllElementsFromFrame": "Alle Elemente aus dem Rahmen entfernen",
    "eyeDropper": "Farbe von der Zeichenfläche auswählen",
    "followUs": "Folge uns",
    "discordChat": "Discord-Chat",
    "zoomToFitViewport": "Zoom auf Ansicht anpassen",
    "zoomToFitSelection": "Zoom auf Auswahl anpassen",
    "zoomToFit": "Zoom auf alle Elemente anpassen",
    "installPWA": "Excalidraw lokal installieren (PWA)",
    "autoResize": "Automatische Textgrößenanpassung",
    "imageCropping": "Bild zuschneiden",
    "unCroppedDimension": "Originalgröße",
    "copyElementLink": "Link zum Objekt kopieren",
    "linkToElement": "Link zum Objekt",
    "wrapSelectionInFrame": "Auswahl in Rahmen einbetten",
    "tab": "Tab",
    "shapeSwitch": "Form wechseln",
    "preferences": "Einstellungen",
    "preferences_toolLock": "Werkzeug sperren",
    "boxSelectionMode": "",
    "boxSelectionContain": "",
    "boxSelectionOverlap": "",
    "arrowBinding": "Pfeilbindung",
    "midpointSnapping": "An Mittelpunkten einrasten"
  },
  "elementLink": {
    "title": "Link zum Objekt",
    "desc": "Klicke auf eine Form auf der Zeichenfläche oder füge einen Link ein.",
    "notFound": "Verknüpftes Objekt wurde nicht auf der Zeichenfläche gefunden."
  },
  "search": {
    "title": "Auf Zeichenfläche suchen",
    "noMatch": "Keine Treffer gefunden...",
    "singleResult": "Ergebnis",
    "multipleResults": "Ergebnisse",
    "placeholder": "Text auf Zeichenfläche suchen...",
    "frames": "Rahmen",
    "texts": "Texte"
  },
  "buttons": {
    "clearReset": "Zeichenfläche löschen & Hintergrundfarbe zurücksetzen",
    "exportJSON": "In Datei exportieren",
    "exportImage": "Bild exportieren...",
    "export": "Speichern als...",
    "copyToClipboard": "In Zwischenablage kopieren",
    "copyLink": "Link kopieren",
    "save": "In aktueller Datei speichern",
    "saveAs": "Speichern unter",
    "load": "Öffnen",
    "getShareableLink": "Teilbaren Link erhalten",
    "close": "Schließen",
    "selectLanguage": "Sprache auswählen",
    "scrollBackToContent": "Zurück zum Inhalt",
    "zoomIn": "Vergrößern",
    "zoomOut": "Verkleinern",
    "resetZoom": "Zoom zurücksetzen",
    "menu": "Menü",
    "done": "Fertig",
    "edit": "Bearbeiten",
    "undo": "Rückgängig machen",
    "redo": "Wiederholen",
    "createNewRoom": "Neuen Raum erstellen",
    "fullScreen": "Vollbildanzeige",
    "darkMode": "Dunkles Design",
    "lightMode": "Helles Design",
    "systemMode": "System-Modus",
    "zenMode": "Zen-Modus",
    "objectsSnapMode": "Einrasten an Objekten",
    "exitZenMode": "Zen-Modus verlassen",
    "cancel": "Abbrechen",
    "clear": "Löschen",
    "remove": "Entfernen",
    "embed": "Einbettung umschalten",
    "submit": "Absenden",
    "confirm": "Bestätigen",
    "embeddableInteractionButton": "Klicken, um zu interagieren"
  },
  "alerts": {
    "clearReset": "Dies wird die ganze Zeichenfläche löschen. Bist du dir sicher?",
    "couldNotCreateShareableLink": "Konnte keinen teilbaren Link erstellen.",
    "couldNotCreateShareableLinkTooBig": "Konnte keinen teilbaren Link erstellen: Die Zeichnung ist zu groß",
    "couldNotLoadInvalidFile": "Ungültige Datei konnte nicht geladen werden",
    "importBackendFailed": "Import vom Server ist fehlgeschlagen.",
    "cannotExportEmptyCanvas": "Leere Zeichenfläche kann nicht exportiert werden.",
    "couldNotCopyToClipboard": "Kopieren in die Zwischenablage fehlgeschlagen.",
    "decryptFailed": "Daten konnten nicht entschlüsselt werden.",
    "uploadedSecurly": "Der Upload wurde mit Ende-zu-Ende-Verschlüsselung gespeichert. Weder Excalidraw noch Dritte können den Inhalt einsehen.",
    "loadSceneOverridePrompt": "Das Laden einer externen Zeichnung ersetzt den vorhandenen Inhalt. Möchtest du fortfahren?",
    "collabStopOverridePrompt": "Das Stoppen der Sitzung wird deine vorherige, lokal gespeicherte Zeichnung überschreiben. Bist du dir sicher?\n\n(Wenn du deine lokale Zeichnung behalten möchtest, schließe stattdessen den Browser-Tab.)",
    "imageDoesNotContainScene": "Dieses Bild scheint keine Szenendaten zu enthalten. Hast du das Einbetten der Szene beim Export aktiviert?",
    "cannotRestoreFromImage": "Die Zeichnung konnte aus dieser Bilddatei nicht wiederhergestellt werden",
    "invalidSceneUrl": "Die Szene konnte nicht von der angegebenen URL importiert werden. Die URL ist entweder fehlerhaft oder enthält keine gültigen Excalidraw-JSON-Daten.",
    "invalidEncryptionKey": "Verschlüsselungsschlüssel muss 22 Zeichen lang sein. Die Live-Zusammenarbeit ist deaktiviert.",
    "collabOfflineWarning": "Keine Internetverbindung verfügbar.\nDeine Änderungen werden nicht gespeichert!",
    "localStorageQuotaExceeded": "Browserspeicher voll. Änderungen werden nicht gespeichert."
  },
  "errors": {
    "unsupportedFileType": "Nicht unterstützter Dateityp.",
    "imageInsertError": "Das Bild konnte nicht eingefügt werden. Versuche es später erneut...",
    "fileTooBig": "Die Datei ist zu groß. Die maximal zulässige Größe ist {{maxSize}}.",
    "svgImageInsertError": "SVG-Bild konnte nicht eingefügt werden. Das SVG-Markup sieht ungültig aus.",
    "failedToFetchImage": "Bild konnte nicht abgerufen werden.",
    "cannotResolveCollabServer": "Konnte keine Verbindung zum Collab-Server herstellen. Bitte lade die Seite neu und versuche es erneut.",
    "collabSaveFailed": "Keine Speicherung in der Backend-Datenbank möglich. Wenn die Probleme weiterhin bestehen, solltest du deine Datei lokal speichern, um sicherzustellen, dass du deine Arbeit nicht verlierst.",
    "collabSaveFailed_sizeExceeded": "Keine Speicherung in der Backend-Datenbank möglich, die Zeichenfläche scheint zu groß zu sein. Du solltest deine Datei lokal speichern, um sicherzustellen, dass du deine Arbeit nicht verlierst.",
    "imageToolNotSupported": "Bilder sind deaktiviert.",
    "brave_measure_text_error": {
      "line1": "Sieht so aus, als ob du den Brave-Browser verwendest und die <bold>aggressive Blockierung von Fingerabdrücken</bold> aktiviert hast.",
      "line2": "Dies könnte dazu führen, dass die <bold>Textelemente</bold> in deinen Zeichnungen nicht korrekt dargestellt werden.",
      "line3": "Wir empfehlen dringend, diese Einstellung zu deaktivieren. Dazu kannst du <link>diesen Schritten</link> folgen.",
      "line4": "Wenn die Deaktivierung dieser Einstellung die fehlerhafte Anzeige von Textelementen nicht behebt, öffne bitte ein <issueLink>Ticket</issueLink> auf unserem GitHub oder schreibe uns auf <discordLink>Discord</discordLink>"
    },
    "asyncPasteFailedOnRead": "Einfügen fehlgeschlagen (konnte aus der Zwischenablage des Systems nicht gelesen werden).",
    "asyncPasteFailedOnParse": "Einfügen fehlgeschlagen.",
    "copyToSystemClipboardFailed": "Kopieren in die Zwischenablage fehlgeschlagen."
  },
  "toolBar": {
    "selection": "Auswahl",
    "lasso": "Lassoauswahl",
    "image": "Bild einfügen",
    "rectangle": "Rechteck",
    "diamond": "Raute",
    "ellipse": "Ellipse",
    "arrow": "Pfeil",
    "line": "Linie",
    "freedraw": "Zeichnen",
    "text": "Text",
    "lock": "Ausgewähltes Werkzeug nach Zeichnen aktiv lassen",
    "penMode": "Stift-Modus - Berührung verhindern",
    "link": "Link für ausgewählte Form hinzufügen / aktualisieren",
    "eraser": "Radierer",
    "frame": "Rahmenwerkzeug",
    "embeddable": "Web-Einbettung",
    "laser": "Laserpointer",
    "autoshape": "",
    "bucketfill": "",
    "hand": "Hand (Schwenkwerkzeug)",
    "extraTools": "Weitere Werkzeuge",
    "convertElementType": "Formtyp umschalten"
  },
  "bucketfill": {
    "noRegion": "",
    "tooComplex": ""
  },
  "element": {
    "rectangle": "Rechteck",
    "diamond": "Raute",
    "ellipse": "Ellipse",
    "arrow": "Pfeil",
    "line": "Linie",
    "freedraw": "Frei zeichnen",
    "text": "Text",
    "image": "Bild",
    "group": "Gruppe",
    "frame": "Rahmen",
    "embeddable": "Web-Einbettung",
    "selection": "Auswahl",
    "iframe": "IFrame"
  },
  "headings": {
    "canvasActions": "Aktionen für Zeichenfläche",
    "selectedShapeActions": "Aktionen für Auswahl",
    "shapes": "Formen"
  },
  "hints": {
    "dismissSearch": "{{shortcut}} zum Schließen der Suche",
    "canvasPanning": "Halte {{shortcut_1}} oder {{shortcut_2}} beim Ziehen gedrückt, um die Zeichenfläche zu verschieben, oder verwende das Handwerkzeug",
    "linearElement": "Klicken für Linie mit mehreren Punkten, Ziehen für einzelne Linie",
    "arrowTool": "Klicken für mehrere Punkte, ziehen für eine einzelne Linie. Drücke erneut {{shortcut}}, um den Pfeiltyp zu wechseln.",
    "arrowBindModifiers": "Halte {{shortcut_1}} gedrückt, um die Bindung zu deaktivieren, oder {{shortcut_2}} für einen festen Ankerpunkt",
    "freeDraw": "Klicke und ziehe. Lass los, wenn du fertig bist",
    "text": "Tipp: Du kannst auch Text hinzufügen, indem du mit dem Auswahlwerkzeug auf eine beliebige Stelle doppelklickst",
    "embeddable": "Klicken und ziehen, um eine Webseiten-Einbettung zu erstellen",
    "autoshape": "",
    "text_selected": "Doppelklicken oder {{shortcut}} drücken, um Text zu bearbeiten",
    "text_editing": "Drücke {{shortcut_1}} oder {{shortcut_2}}, um die Bearbeitung abzuschließen",
    "linearElementMulti": "Klicke auf den letzten Punkt oder drücke {{shortcut_1}} oder {{shortcut_2}} zum Abschließen",
    "lockAngle": "Halte {{shortcut}} gedrückt, um den Winkel einzuschränken",
    "resize": "Halte {{shortcut_1}} gedrückt, um die Proportionen beizubehalten.\n{{shortcut_2}} gedrückt halten, um von der Mitte aus zu skalieren",
    "resizeImage": "Halte {{shortcut_1}} gedrückt, um frei zu skalieren.\n{{shortcut_2}} gedrückt halten, um von der Mitte aus zu skalieren",
    "rotate": "Halte {{shortcut}} gedrückt, um den Winkel einzuschränken",
    "toggleArrowhead": "",
    "lineEditor_info": "Halte {{shortcut_1}} gedrückt und doppelklicke oder drücke {{shortcut_2}}, um Punkte zu bearbeiten",
    "lineEditor_line_info": "Doppelklicken oder {{shortcut}} drücken, um Punkte zu bearbeiten",
    "lineEditor_pointSelected": "Drücke {{shortcut_1}}, um Punkt(e) zu entfernen,\n{{shortcut_2}} zum Duplizieren, oder ziehe zum Verschieben",
    "lineEditor_nothingSelected": "Wähle einen Punkt zum Bearbeiten (halte {{shortcut_1}} für Mehrfachauswahl),\noder halte {{shortcut_2}} gedrückt und klicke, um neue Punkte hinzuzufügen",
    "bindTextToElement": "{{shortcut}} zum Hinzufügen von Text",
    "createFlowchart": "{{shortcut}} zum Erstellen eines Flussdiagramms",
    "deepBoxSelect": "Halte {{shortcut}} gedrückt für Tiefenauswahl und um Ziehen zu verhindern",
    "eraserRevert": "Halte {{shortcut}} gedrückt, um zum Löschen markierte Elemente wiederherzustellen",
    "firefox_clipboard_write": "Diese Funktion kann wahrscheinlich aktiviert werden, indem die Einstellung \"dom.events.asyncClipboard.clipboardItem\" auf \"true\" gesetzt wird. Um die Browsereinstellungen in Firefox zu ändern, besuche die Seite \"about:config\".",
    "disableSnapping": "Halte {{shortcut}} gedrückt, um Einrasten zu deaktivieren",
    "enterCropEditor": "Doppelklicke auf das Bild oder drücke {{shortcut}}, um das Bild zuzuschneiden",
    "leaveCropEditor": "Klicke außerhalb des Bildes oder drücke {{shortcut_1}} oder {{shortcut_2}}, um das Zuschneiden abzuschließen"
  },
  "canvasError": {
    "cannotShowPreview": "Vorschau kann nicht angezeigt werden",
    "canvasTooBig": "Die Zeichenfläche ist möglicherweise zu groß.",
    "canvasTooBigTip": "Tipp: Schiebe die am weitesten entfernten Elemente ein wenig näher zusammen."
  },
  "errorSplash": {
    "headingMain": "Es ist ein Fehler aufgetreten. Versuche <button>die Seite neu zu laden.</button>",
    "clearCanvasMessage": "Wenn das Neuladen nicht funktioniert, versuche <button>die Zeichenfläche zu löschen.</button>",
    "clearCanvasCaveat": " Dies wird zum Verlust von Daten führen ",
    "trackedToSentry": "Der Fehler mit der Kennung {{eventId}} wurde in unserem System registriert.",
    "openIssueMessage": "Wir waren sehr vorsichtig und haben deine Zeichnungsinformationen nicht in die Fehlerinformationen aufgenommen. Wenn deine Zeichnung nicht privat ist, unterstütze uns bitte über unseren <button>Bug-Tracker</button>. Bitte teile die unten stehenden Informationen mit uns im GitHub Issue (Kopieren und Einfügen).",
    "sceneContent": "Zeichnungsinhalt:"
  },
  "shareDialog": {
    "or": "Oder"
  },
  "roomDialog": {
    "desc_intro": "Lade Leute ein, an deiner Zeichnung mitzuarbeiten.",
    "desc_privacy": "Keine Sorge, die Sitzung ist Ende-zu-Ende verschlüsselt und vollständig privat. Nicht einmal unser Server kann sehen, was du zeichnest.",
    "button_startSession": "Sitzung starten",
    "button_stopSession": "Sitzung beenden",
    "desc_inProgressIntro": "Die Live-Sitzung wird nun ausgeführt.",
    "desc_shareLink": "Teile diesen Link mit allen, mit denen du zusammenarbeiten möchtest:",
    "desc_exitSession": "Wenn du die Sitzung beendest, wird deine Verbindung zum Raum getrennt. Du kannst jedoch lokal weiter an der Zeichnung arbeiten. Beachte, dass dies keine Auswirkungen auf andere hat und diese weiterhin gemeinsam an ihrer Version arbeiten können.",
    "shareTitle": "An einer Live-Kollaborationssitzung auf Excalidraw teilnehmen"
  },
  "errorDialog": {
    "title": "Fehler"
  },
  "progressDialog": {
    "title": "Speichern",
    "defaultMessage": "Speicherung wird vorbereitet..."
  },
  "exportDialog": {
    "disk_title": "Auf Festplatte speichern",
    "disk_details": "Exportiere die Zeichnungsdaten in eine Datei, aus der du später importieren kannst.",
    "disk_button": "Als Datei speichern",
    "link_title": "Teilbarer Link",
    "link_details": "Als schreibgeschützten Link exportieren.",
    "link_button": "Als Link exportieren",
    "excalidrawplus_description": "Speichere die Szene in deinem Excalidraw+ Arbeitsbereich.",
    "excalidrawplus_button": "Exportieren",
    "excalidrawplus_exportError": "Konnte nicht nach Excalidraw+ exportieren..."
  },
  "helpDialog": {
    "blog": "Lies unseren Blog",
    "click": "klicken",
    "deepSelect": "Auswahl innerhalb der Gruppe",
    "deepBoxSelect": "Auswahl innerhalb der Gruppe, und Ziehen vermeiden",
    "createFlowchart": "Erstelle ein Flussdiagramm aus einem generischen Element",
    "navigateFlowchart": "Durch ein Flussdiagramm navigieren",
    "curvedArrow": "Gebogener Pfeil",
    "curvedLine": "Gebogene Linie",
    "documentation": "Dokumentation",
    "doubleClick": "doppelklicken",
    "drag": "ziehen",
    "editor": "Editor",
    "editLineArrowPoints": "Linien-/Pfeil-Punkte bearbeiten",
    "editText": "Text bearbeiten / Label hinzufügen",
    "github": "Ein Problem gefunden? Informiere uns",
    "howto": "Folge unseren Anleitungen",
    "or": "oder",
    "preventBinding": "Pfeil-Bindung verhindern",
    "tools": "Werkzeuge",
    "shortcuts": "Tastaturkürzel",
    "textFinish": "Bearbeitung beenden (Texteditor)",
    "textNewLine": "Neue Zeile hinzufügen (Texteditor)",
    "title": "Hilfe",
    "view": "Ansicht",
    "zoomToFit": "Zoomen um alle Elemente einzupassen",
    "zoomToSelection": "Auf Auswahl zoomen",
    "toggleElementLock": "Auswahl sperren/entsperren",
    "movePageUpDown": "Seite nach oben/unten verschieben",
    "movePageLeftRight": "Seite nach links/rechts verschieben",
    "cropStart": "Bild zuschneiden",
    "cropFinish": "Zuschneiden des Bildes beenden"
  },
  "clearCanvasDialog": {
    "title": "Zeichenfläche löschen"
  },
  "imageExportDialog": {
    "header": "Bild exportieren",
    "label": {
      "withBackground": "Hintergrund",
      "onlySelected": "Nur ausgewählte",
      "darkMode": "Dunkler Modus",
      "embedScene": "Szene einbetten",
      "scale": "Skalierung",
      "padding": "Abstand"
    },
    "tooltip": {
      "embedScene": "Die Zeichnungsdaten werden in der exportierten PNG/SVG-Datei gespeichert, sodass die Szene daraus wiederhergestellt werden kann.\nDadurch wird die exportierte Datei größer."
    },
    "title": {
      "exportToPng": "Als PNG exportieren",
      "exportToSvg": "Als SVG exportieren",
      "copyPngToClipboard": "PNG in die Zwischenablage kopieren"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "In Zwischenablage kopieren"
    }
  },
  "encrypted": {
    "tooltip": "Da deine Zeichnungen Ende-zu-Ende verschlüsselt werden, sehen auch unsere Excalidraw-Server sie niemals.",
    "link": "Blogbeitrag über Ende-zu-Ende-Verschlüsselung in Excalidraw"
  },
  "stats": {
    "angle": "Winkel",
    "shapes": "Formen",
    "height": "Höhe",
    "scene": "Zeichnung",
    "selected": "Ausgewählt",
    "storage": "Speicher",
    "fullTitle": "Zeichenflächen- & Formeigenschaften",
    "title": "Eigenschaften",
    "generalStats": "Allgemein",
    "elementProperties": "Formeigenschaften",
    "total": "Gesamt",
    "version": "Version",
    "versionCopy": "Zum Kopieren klicken",
    "versionNotAvailable": "Version nicht verfügbar",
    "width": "Breite"
  },
  "toast": {
    "copyStyles": "Formatierungen kopiert.",
    "copyToClipboard": "In die Zwischenablage kopiert.",
    "copyToClipboardAsPng": "{{exportSelection}} als PNG in die Zwischenablage kopiert\n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "{{exportSelection}} als SVG in die Zwischenablage kopiert ({{exportColorScheme}})",
    "fileSaved": "Datei gespeichert.",
    "fileSavedToFilename": "Als {filename} gespeichert",
    "canvas": "Zeichenfläche",
    "selection": "Auswahl",
    "pasteAsSingleElement": "Verwende {{shortcut}} , um als einzelnes Element\neinzufügen oder in einen existierenden Texteditor einzufügen",
    "unableToEmbed": "Einbetten dieser URL ist derzeit nicht zulässig. Erstelle einen Issue auf GitHub, um die URL freigeben zu lassen",
    "unrecognizedLinkFormat": "Der eingebettete Link stimmt nicht mit dem erwarteten Format überein. Bitte versuche, den Einbettungs-Code der Quellseite einzufügen",
    "elementLinkCopied": "Link in Zwischenablage kopiert"
  },
  "colors": {
    "transparent": "Transparent",
    "black": "Schwarz",
    "white": "Weiß",
    "red": "Rot",
    "pink": "Pink",
    "grape": "Traube",
    "violet": "Violett",
    "gray": "Grau",
    "blue": "Blau",
    "cyan": "Cyan",
    "teal": "Blaugrün",
    "green": "Grün",
    "yellow": "Gelb",
    "orange": "Orange",
    "bronze": "Bronze"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "Deine Zeichnungen werden im Browserspeicher gespeichert.",
      "center_heading_line2": "Der Browserspeicher kann unerwartet gelöscht werden.",
      "center_heading_line3": "Speichere deine Arbeit regelmäßig in einer Datei, um Datenverlust zu vermeiden.",
      "center_heading_plus": "Möchtest du stattdessen zu Excalidraw+ gehen?",
      "menuHint": "Exportieren, Einstellungen, Sprachen, ..."
    },
    "defaults": {
      "menuHint": "Exportieren, Einstellungen und mehr...",
      "center_heading": "Diagramme. Einfach. Gemacht.",
      "toolbarHint": "Wähle ein Werkzeug & beginne zu zeichnen!",
      "helpHint": "Kurzbefehle & Hilfe"
    }
  },
  "colorPicker": {
    "color": "Farbe",
    "mostUsedCustomColors": "Beliebteste benutzerdefinierte Farben",
    "colors": "Farben",
    "shades": "Schattierungen",
    "hexCode": "Hex-Code",
    "noShades": "Keine Schattierungen für diese Farbe verfügbar",
    "invalidColor": "",
    "invalidHexLength": "",
    "topPicksTip": "",
    "resetTopPicks": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "Als Bild exportieren",
        "button": "Als Bild exportieren",
        "description": "Exportiere die Zeichnungsdaten als Bild, aus dem du später importieren kannst."
      },
      "saveToDisk": {
        "title": "Auf Festplatte speichern",
        "button": "Auf Festplatte speichern",
        "description": "Exportiere die Zeichnungsdaten in eine Datei, aus der du später importieren kannst."
      },
      "excalidrawPlus": {
        "title": "Excalidraw+",
        "button": "Export nach Excalidraw+",
        "description": "Speichere die Szene in deinem Excalidraw+-Arbeitsbereich."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "Aus Datei laden",
        "button": "Aus Datei laden",
        "description": "Das Laden aus einer Datei wird <bold>deinen vorhandenen Inhalt ersetzen</bold>.<br></br>Du kannst deine Zeichnung zuerst mit einer der folgenden Optionen sichern."
      },
      "shareableLink": {
        "title": "Aus Link laden",
        "button": "Meinen Inhalt ersetzen",
        "description": "Das Laden einer externen Zeichnung wird <bold>deinen vorhandenen Inhalt ersetzen</bold>.<br></br>Du kannst deine Zeichnung zuerst mit einer der folgenden Optionen sichern."
      }
    }
  },
  "quickSearch": {
    "placeholder": "Schnellsuche"
  },
  "fontList": {
    "badge": {
      "old": "alt"
    },
    "sceneFonts": "In dieser Szene",
    "availableFonts": "Verfügbare Schriftarten",
    "empty": "Keine Schriftarten gefunden"
  },
  "userList": {
    "empty": "Keine Benutzer gefunden",
    "hint": {
      "text": "Klicke auf Benutzer um zu folgen",
      "followStatus": "Du folgst derzeit diesem Benutzer",
      "inCall": "Benutzer ist in einem Sprachanruf",
      "micMuted": "Mikrofon des Benutzers ist stumm geschaltet",
      "isSpeaking": "Benutzer spricht"
    }
  },
  "keys": {
    "ctrl": "Strg",
    "option": "Option",
    "cmd": "Cmd",
    "alt": "Alt",
    "escape": "Esc",
    "enter": "Eingabe",
    "shift": "Umschalt",
    "spacebar": "Leertaste",
    "delete": "Löschen",
    "mmb": "Mausrad"
  }
}
